import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { Icon } from '@cfp/ui';
import { TranslateModule } from '@ngx-translate/core';
import { MeasureStatusDTO } from 'csr-asset-app';

@Component({
  templateUrl: 'measure-status-action-button.html',
  selector: 'cfp-measure-status-action-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Icon, TranslateModule]
})
export class MeasureStatusActionButton {
  public readonly saveStatus = output<MeasureStatusDTO>();

  protected readonly status = input.required<MeasureStatusDTO>();
  protected readonly selectedStatus = input.required<MeasureStatusDTO>();
  protected readonly iconStyle = input.required<
    'measure-status-planned' | 'measure-status-implemented' | 'measure-status-outofscope'
  >();

  protected readonly MeasureStatusDTO = MeasureStatusDTO;

  protected saveStatusClick(event: Event): void {
    event.preventDefault();
    event.stopImmediatePropagation();

    setTimeout(() => {
      // Timeout is need to prevent ExpressionChangedAfterItHasBeenCheckedError
      this.saveStatus.emit(this.status());
    });
  }
}
